import { render, staticRenderFns } from "./uppy_damage_image.vue?vue&type=template&id=8ecf4d48&scoped=true"
import script from "./uppy_damage_image.vue?vue&type=script&lang=js"
export * from "./uppy_damage_image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecf4d48",
  null
  
)

export default component.exports